const state = {
  locale: 'en_GB',
  notificationInstance: null,
  countries: [],
  titles: [],
};
export default state;
